
import { defineComponent } from "vue";
import { googleOneTap } from "vue3-google-login"

export default defineComponent({
  name: "Login",
  data() {
    return {
      form: { username: "", password: "", remember_me: false },
      messages: {
        error: {
          both: "",
          username: "",
          password: "",
        },
      },
      loading: false,
    };
  },
  mounted() {
    const input = this.$refs.username as HTMLInputElement;
    const btnSubmit = this.$refs.btnSubmit as HTMLButtonElement;

    try {
      googleOneTap().then(this.callback);
    } catch(error) {
      console.error(error);
    }

    setTimeout(() => {
      if (input.matches(":-webkit-autofill")) {
        btnSubmit.removeAttribute("disabled");
      }
    }, 500);
  },
  methods: {
    callback(response: any) {
      this.loading = true;
      this.$store
        .dispatch("auth/login_google", { token: response.credential, remember_me: this.form.remember_me })
        .then(() => this.$router.push("/"))
        .catch((error) => {
          this.loading = false;
          return (this.messages.error.both =
            error.msg ||
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString() ||
            "Unexpected error.");
        });
    },
    checkForm(usern = true, passw = true) {
      let isValid = true;
      if (!this.form.username && usern)
        (this.messages.error.username = "Campo vazio"), (isValid = false);
      else if (usern) this.messages.error.username = "";
      if (!this.form.password && passw)
        (this.messages.error.password = "Campo vazio"), (isValid = false);
      else if (passw) this.messages.error.password = "";

      return isValid;
    },
    submit() {
      if (!this.checkForm()) return;

      this.loading = true;
      this.$store
        .dispatch("auth/login", this.form)
        .then(() => this.$router.push("/"))
        .catch((error) => {
          this.loading = false;
          return (this.messages.error.both =
            error.msg ||
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString() ||
            "Unexpected error.");
        });
    },
  },
  watch: {
    "form.username": function () {
      this.checkForm(true, false);
    },
    "form.password": function () {
      this.checkForm(false);
    },
  },
});
